/**
 * Strips HTML tags from a string. Used to derive a plain-text fallback from the
 * event-type's rich-text description for places where HTML can't render —
 * notably the iCal `DESCRIPTION` field and Google Calendar `details` query
 * param, both of which display the input verbatim.
 *
 * @param {string} html - The HTML string to flatten.
 * @returns {string} Plain text with tags removed and whitespace collapsed.
 */
const stripHtml = (html: string): string => {
  const withoutTags = html.replace(/<[^>]+>/gu, ' ')
  const decoded = withoutTags
    .replace(/&nbsp;/gu, ' ')
    .replace(/&amp;/gu, '&')
    .replace(/&lt;/gu, '<')
    .replace(/&gt;/gu, '>')
    .replace(/&quot;/gu, '"')
    .replace(/&#39;/gu, "'")
  return decoded.replace(/\s+/gu, ' ').trim()
}

export { stripHtml }
